import React, {useContext, useEffect, useMemo, useState} from 'react';
import {useLocation} from "react-router-dom";

import {PAContext} from "../../../Services/PAContext";
import {
    Alert,
    Avatar,
    Button,
    Card,
    CardContent,
    Chip,
    FormControl,
    MenuItem, Paper,
    Select,
    TextField
} from "@mui/material";


import DOMPurify from 'dompurify';


import {useDropzone} from 'react-dropzone';

import './details.css';
import Typography from "@mui/material/Typography";
import Badge from "@mui/material/Badge";
import Box from "@mui/material/Box";
import usePA_GlobalStore from "../../../Services/ZustandGlobalStore";
import {getAllEventsFromDatabase} from "../../../Services/BrowserDatabaseFunctions";





function DetailsView(props){


    const location = useLocation();

    const { PA_GlobalObject, set_PA_GlobalObject } = usePA_GlobalStore();

    const { dataArray, setShowSuccessSnackbar, sendSocketMessage  } = useContext(PAContext);
    const { Account, authenticated } = dataArray;

    const [detailsTabSelected, setDetailsTabSelected] = useState("Name");
    const [eventTitle, setEventTitle] = useState(PA_GlobalObject.Planning.title || PA_GlobalObject.Planning.name || "");

    useEffect(() => {
        if (location.state?.selectedTab !== undefined) {
            props.setShowEventItemConfig(true);
            setDetailsTabSelected(location.state.selectedTab); // Set the active tab from state
        }
    }, [location.state]);

    function handleFooterItemClick(_item){
        detailsTabSelected === _item ? setDetailsTabSelected("") : setDetailsTabSelected(_item)
    }
    function handleEventTitleChange(event){
        setEventTitle(event.target.value);
    }
    function handleEventTitleUpdate(){

        //update the Planning
        set_PA_GlobalObject((prev) => ({
            Planning: {
                ...prev.Planning, // Retain all existing fields in Planning
                title: eventTitle, // Update only the title
            },
        }));

        //if this is an Event (not Planning)
        //send change to server
        if (PA_GlobalObject.Planning.status!== 10){
            const _sendString = {};
            _sendString.action = "E_updateEventName";
            _sendString.event_id = PA_GlobalObject.Planning.id;
            _sendString.event_name = eventTitle;
            sendSocketMessage(_sendString);
        }

    }


    // --- 1. STATE DECLARATIONS ---
    const [needToSaveImage, setNeedToSaveImage] = useState(false);
    const [coverImageData, setCoverImageData] = useState(
        PA_GlobalObject.Planning.coverImage?.thumbnail?.thumbnail_data
        || PA_GlobalObject.Planning.cover_image_thumbnail
        || "https://plannedadventure.com/assets/images/user_bg1.png"
    );
    const [pendingImageData, setPendingImageData] = useState(null);

    // --- 2. SYNC EFFECT (Keep UI updated from Global Store) ---
    useEffect(() => {
        if (PA_GlobalObject.Planning.coverImage?.thumbnail) {
            const thumb = PA_GlobalObject.Planning.coverImage.thumbnail;
            setCoverImageData(thumb.thumbnail_data);
            setPendingImageData({
                name: thumb.name,
                size: thumb.size,
                width: thumb.width,
                height: thumb.height
            });
        }
    }, [PA_GlobalObject.Planning.coverImage]);

    // --- 3. DROPZONE LOGIC ---
    const { getRootProps, getInputProps } = useDropzone({
        accept: { "image/jpeg": [], "image/png": [], "image/gif": [] },
        multiple: false,
        onDrop: (acceptedFiles) => {
            const file = acceptedFiles[0];
            if (!file) return;

            const reader = new FileReader();
            reader.onload = (event) => {
                const img = new Image();
                img.onload = () => {
                    // Create the unified object
                    const photoObject = {
                        file: file,
                        file_name: file.name,
                        file_size: file.size,
                        file_type: file.type,
                        width: img.width,
                        height: img.height,
                        full_data: event.target.result, // The full Base64 string for preview
                        temp_id: "EVENT_COVER" // Use a constant ID for the Map
                    };

                    setPendingImageData(photoObject);
                    setCoverImageData(event.target.result); // For the UI preview
                    setNeedToSaveImage(true);
                };
                img.src = event.target.result;
            };
            reader.readAsDataURL(file);
        }
    });

    // --- 4. THE SAVE FUNCTION ---
    const handleEventCoverImageSave = () => {
        console.log("handleEventCoverImageSave");

        const eventId = PA_GlobalObject?.Planning?.id;

        console.log("pendingImageData : ", pendingImageData);

        if (!pendingImageData) return;

        set_PA_GlobalObject((prev) => {
            // 1. Keep your logic to disable the slideshow
            //make sure it's only for this attendee though where photo.attendee_id === Account.id
            const updatedPhotos = (prev.Planning.photos || []).map(photo => {
                if (photo.attendee_id === Account.id) {
                    return {
                        ...photo,
                        photo_album: false
                    };
                }
                return photo; // Leave other people's photos alone
            });

            return {
                ...prev,
                Planning: {
                    ...prev.Planning,
                    photos: updatedPhotos,
                    // 2. Map the data to the correct keys
                    coverImage: {
                        // This is the "Full" version (The Truth)
                        full: {
                            ...pendingImageData,
                            full_data: pendingImageData.full_data, // High-res Base64
                            gcs_path: "" // Will be filled after GCS upload
                        },
                        // This is a placeholder until the server generates a real thumb
                        thumbnail: {
                            ...pendingImageData,
                            thumbnail_data: pendingImageData.full_data // Same data, but labeled as thumb
                        }
                    }
                }
            };
        });

        if (PA_GlobalObject.Planning.status !== 10) {
            // Clear existing cover flags on the server
            sendSocketMessage({
                action: "E_resetEventCoverPhotos",
                event_id: eventId
            });

            // Request GCS Signed URL for the high-res version
            sendSocketMessage({
                action: "E_requestEventCoverImageUploadUrlForGCS",
                event_id: eventId,
                file_name: pendingImageData.file_name,
                file_type: pendingImageData.file_type
            });

            // Register for the actual PUT upload using your Map pattern
            try {
                // Use your Map pattern for the actual PUT upload
                window.pendingUploads = window.pendingUploads || new Map();
                window.pendingUploads.set(pendingImageData.temp_id, pendingImageData);
            } catch (err) {
                console.error("Processing failed for cover:", err);
            }

        }

        setNeedToSaveImage(false); // Hide the button after saving
    };

    /*
        for the Event Introduction/description
     */
    // 1. In your component logic:
    const [userInput, setUserInput] = useState(PA_GlobalObject.Planning.eventIntro || "");
    const [sanitizedContent, setSanitizedContent] = useState(PA_GlobalObject.Planning.eventIntro || "");

    const handleInputChange = (event) => {
        setUserInput(event.target.value);
    };

    const renderContent = () => {
        // We sanitize exactly what is in the box right now
        // Note: If you want to support raw HTML, removing the \n to <br> replace
        // is better so users have full control over their tags.
        const clean = DOMPurify.sanitize(userInput);
        setSanitizedContent(clean);
    };

    // Logic for showing the Save button:
    // Only show Save if the preview they are looking at matches their current input
    const needToSaveIntro = userInput !== PA_GlobalObject.Planning.eventIntro;

    function handleEventCoverIntroSave() {

        set_PA_GlobalObject((prev) => ({
            ...prev,
            Planning: {
                ...prev.Planning,
                eventIntro: sanitizedContent,
            },
        }));

        if (PA_GlobalObject.Planning.status !== 10) {
            sendSocketMessage({
                action: "E_updateEventCoverIntro",
                event_id: PA_GlobalObject.Planning.id,
                event_intro: sanitizedContent // Send the clean HTML
            });
        }
    }


    /* --- Event Categories Logic --- */

    const _event_categories = [
        "Birthdays",
        "Holidays",
        "Reunions",
        "Anniversaries",
        "Vacations",
        "Weddings",
        "Weekends",
        "Sporting Events",
        "Family Getaways"
    ];

    // 1. Memoized check for attendee status
    const isAttendee = useMemo(() => {
        const planning = PA_GlobalObject?.Planning;
        const attendees = planning?.attendees || [];
        return Account?.id !== undefined && attendees.some((attendee) => attendee.id === Account.id);
    }, [Account?.id, PA_GlobalObject?.Planning?.attendees]);

    // 2. State
    const [enableUpdateButton, setEnableUpdateButton] = useState(false);
    const [needToUpdate, setNeedToUpdate] = useState(false);
    const [eventCategories, setEventCategories] = useState(_event_categories);
    const [selectedEventCategories, setSelectedEventCategories] = useState([]);
    const [newCategory, setNewCategory] = useState("");

    // 3. Load categories from Zustand Global Store & IndexedDB Browser Storage
    useEffect(() => {
        const loadCategories = async () => {
            const _previously_selected = [];
            const _historical_attendee_categories = [];

            // A. Check current active workspace (PA_GlobalObject.Planning) FIRST
            const currentMenuItems = PA_GlobalObject?.Planning?.menu_items || [];
            const userMenuItem = currentMenuItems.find(item => item.id === Account?.id);

            if (userMenuItem && Array.isArray(userMenuItem.categories)) {
                _previously_selected.push(...userMenuItem.categories);
            }

            // B. Fetch events directly from the browser database using Account.id
            if (Account?.id) {
                try {
                    const dbEvents = await getAllEventsFromDatabase(Account.id);

                    if (dbEvents && Array.isArray(dbEvents) && dbEvents.length > 0) {
                        for (const _event of dbEvents) {
                            for (const _menu_item of (_event.menu_items || [])) {
                                if (_menu_item.id === Account.id) {
                                    for (const _cat of (_menu_item.categories || [])) {
                                        _historical_attendee_categories.push(_cat);

                                        // Fallback: If no current selection in store, grab from matching saved DB event
                                        if (_previously_selected.length === 0 && _event.id === PA_GlobalObject?.Planning?.id) {
                                            _previously_selected.push(_cat);
                                        }
                                    }
                                }
                            }
                        }
                    }
                } catch (error) {
                    console.error("Error loading events from browser database for categories:", error);
                }
            }

            const uniqueSelected = [...new Set(_previously_selected)];

            // C. Combine all tags and sort: Selected first (A-Z), then Unselected (A-Z)
            const allCombinedCategories = [
                ...new Set([
                    ..._event_categories,
                    ..._historical_attendee_categories,
                    ...uniqueSelected
                ])
            ].sort((a, b) => {
                const isASelected = uniqueSelected.includes(a);
                const isBSelected = uniqueSelected.includes(b);

                // If one is selected and the other isn't, selected comes first
                if (isASelected && !isBSelected) return -1;
                if (!isASelected && isBSelected) return 1;

                // Otherwise sort alphabetically
                return a.localeCompare(b);
            });

            setEventCategories(allCombinedCategories);
            setSelectedEventCategories(uniqueSelected);
        };

        loadCategories();
    }, [PA_GlobalObject?.Planning?.id, Account?.id]);

    // 4. Sort helper function whenever selection state changes dynamically
    const sortCategoriesWithSelectedFirst = (categoriesList, currentSelected) => {
        return [...categoriesList].sort((a, b) => {
            const isASelected = currentSelected.includes(a);
            const isBSelected = currentSelected.includes(b);

            if (isASelected && !isBSelected) return -1;
            if (!isASelected && isBSelected) return 1;

            return a.localeCompare(b);
        });
    };

    // 5. Handlers
    const handleEventCategoryNewCategory = (e) => setNewCategory(e.target.value);

    const handleEventCategoryAddNewCategory = () => {
        const trimmed = newCategory.trim();
        if (!trimmed) return;

        const exists = eventCategories.some(cat => cat.toLowerCase() === trimmed.toLowerCase());

        // Auto-select the newly added category
        const updatedSelected = selectedEventCategories.includes(trimmed)
            ? selectedEventCategories
            : [...selectedEventCategories, trimmed];

        const baseList = exists ? eventCategories : [...eventCategories, trimmed];

        // Resort array so the new category moves to the top selected group
        setEventCategories(sortCategoriesWithSelectedFirst(baseList, updatedSelected));
        setSelectedEventCategories(updatedSelected);
        setNeedToUpdate(true);
        setNewCategory('');
    };

    const handleEventCategoryToggleSelectedCategory = (category) => {
        const updatedSelected = selectedEventCategories.includes(category)
            ? selectedEventCategories.filter(c => c !== category)
            : [...selectedEventCategories, category];

        setSelectedEventCategories(updatedSelected);

        // Re-sort category list so selected tags float to the top
        setEventCategories(prev => sortCategoriesWithSelectedFirst(prev, updatedSelected));
        setNeedToUpdate(true);
    };

    const handleEventCategoriesUpdate = () => {
        if (Account?.id !== undefined && isAttendee) {
            const currentPlanning = PA_GlobalObject?.Planning || {};
            const menuItems = [...(currentPlanning.menu_items || [])];
            const existingItemIndex = menuItems.findIndex((item) => item.id === Account.id);

            if (existingItemIndex !== -1) {
                menuItems[existingItemIndex] = {
                    ...menuItems[existingItemIndex],
                    categories: [...selectedEventCategories],
                };
            } else {
                menuItems.push({
                    id: Account.id,
                    categories: [...selectedEventCategories],
                });
            }

            // Save into Zustand Global Store
            set_PA_GlobalObject((prev) => ({
                ...prev,
                Planning: { ...prev.Planning, menu_items: menuItems },
            }));

            setShowSuccessSnackbar(true);
            setNeedToUpdate(false);

            // If this is an active Event (not planning/draft), send change to server
            if (PA_GlobalObject.Planning.status !== 10) {
                const _sendString = {};
                _sendString.action = "E_updateEventCategories";
                _sendString.event_id = PA_GlobalObject.Planning.id;
                _sendString.categories = selectedEventCategories;

                sendSocketMessage(_sendString);
            }
        }
    };

    // 6. Validation Effect
    useEffect(() => {
        const _loggedIn = (Account?.id !== undefined);
        setEnableUpdateButton(_loggedIn && isAttendee && needToUpdate);
    }, [selectedEventCategories, needToUpdate, isAttendee, Account?.id]);


    /*
           for the Event Status
    */
    const currentPlanningStatus = PA_GlobalObject.Planning?.status ?? 10;
    const [status, setStatus] = useState(currentPlanningStatus);

    // 2. Keep local status in sync when PA_GlobalObject updates in Zustand
    useEffect(() => {
        if (PA_GlobalObject.Planning?.status !== undefined) {
            setStatus(PA_GlobalObject.Planning.status);
        }
    }, [PA_GlobalObject.Planning?.status]);
    const isEventSavedAndPaid =
        authenticated &&
        Account?.id !== undefined &&
        PA_GlobalObject.Planning.id !== PA_GlobalObject.Planning.temp_id &&
        PA_GlobalObject.Planning.status !== 10;

    function handleEventStatusUpdate(e){
        const newStatus = Number(e.target.value);
        const currentStatus = PA_GlobalObject.Planning.status;

        // Guard: If currently in Planning Phase (10) and not paid for, block status updates
        if (currentStatus === 10 && newStatus !== 10 && !isEventSavedAndPaid) {
            return;
        }

        setStatus(newStatus);

        // Update the Planning state in global store
        set_PA_GlobalObject((prev) => ({
            Planning: {
                ...prev.Planning, // Retain all existing fields in Planning
                closed: newStatus === 0 || newStatus === 2 ? 0 : 1,
                status: newStatus,
            },
        }));

        // Send change to server if this is an Event (not local draft/planning)
        if (PA_GlobalObject.Planning.status !== 10){
            const _sendString = {};
            _sendString.action = "E_updateEventStatus";
            _sendString.event_id = PA_GlobalObject.Planning.id;
            _sendString.status = newStatus;
            sendSocketMessage(_sendString);
        }

        setShowSuccessSnackbar(true);
    }

    function handleEventStatusUpdateOLD(e){
        setStatus(e.target.value);

        //update the Planning
        set_PA_GlobalObject((prev) => ({
            Planning: {
                ...prev.Planning, // Retain all existing fields in Planning
                closed: e.target.value === 0 || e.target.value === 2 ? 0 : 1,
                status: e.target.value,
            },
        }));

        //if this is an Event (not Planning)
        //send change to server
        if (PA_GlobalObject.Planning.status!== 10){
            const _sendString = {};
            _sendString.action = "E_updateEventStatus";
            _sendString.event_id = PA_GlobalObject.Planning.id;
            _sendString.status = e.target.value;
            sendSocketMessage(_sendString);

        }

        //show that it was successful
        setShowSuccessSnackbar(true);
    }



    return (

        <div className="details-list-container" >
            {/* show the header */}
            <Paper
                elevation={0}
                sx={{
                    p: 1.5,
                    background: 'rgba(255, 255, 255, 0.8)',
                    backdropFilter: 'blur(12px)',
                    border: '1px solid rgba(255, 255, 255, 0.6)',
                    boxShadow: '0 4px 24px -6px rgba(0,0,0,0.06)',
                    borderRadius: '12px 12px 0 0',
                }}
            >
                <Box
                    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                >
                    {/* Left Side: Icon and Title Group */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box
                            sx={{
                                background: 'linear-gradient(135deg, #6366f1 0%, #a855f7 100%)',
                                p: 0.9,
                                borderRadius: '10px',
                                display: 'flex',
                                boxShadow: '0 4px 10px rgba(99, 102, 241, 0.3)'
                            }}
                        >
                            <i className="icon-settings-icons" style={{ color: 'white', fontSize: '18px' }} />
                        </Box>

                        <Box>
                            <Box sx={{ minWidth: 0 }}>
                                <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b', fontSize: '1rem', letterSpacing: -0.4, whiteSpace: 'nowrap' }}>
                                    Event Details
                                </Typography>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                    <i className="icon-fireworks" style={{ color: '#8b5cf6', fontSize: '10px' }} />
                                    <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 700, fontSize: '0.65rem', letterSpacing: 0.1, whiteSpace: 'nowrap' }}>
                                        Overview & Appearance
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Box>

                    {/* Right Side: Dynamic Event Status Badge */}
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-end',
                            gap: 0.5
                        }}
                    >
                        {(() => {
                            // Configuration mapping for each status level
                            const statusMap = {
                                10: { label: 'Planning', color: '#1e40af', bg: '#eff6ff', border: '#dbeafe', dot: '#3b82f6' }, // Blue
                                0:  { label: 'Open', color: '#166534', bg: '#f0fdf4', border: '#dcfce7', dot: '#22c55e' },    // Green
                                2:  { label: 'Rescheduled', color: '#92400e', bg: '#fffbeb', border: '#fef3c7', dot: '#f59e0b' }, // Amber
                                1:  { label: 'Closed', color: '#374151', bg: '#f3f4f6', border: '#e5e7eb', dot: '#6b7280' },    // Grey
                                3:  { label: 'Cancelled', color: '#991b1b', bg: '#fef2f2', border: '#fee2e2', dot: '#ef4444' }, // Red
                            };

                            const currentStatus = statusMap[PA_GlobalObject.Planning.status] || statusMap[10];

                            return (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1,
                                        bgcolor: currentStatus.bg,
                                        px: 1.5,
                                        py: 0.6,
                                        borderRadius: '12px',
                                        border: `1px solid ${currentStatus.border}`,
                                        transition: 'all 0.3s ease'
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontSize: '11px',
                                            fontWeight: 800,
                                            color: currentStatus.color,
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.05em'
                                        }}
                                    >
                                        {currentStatus.label}
                                    </Typography>
                                    <Box
                                        sx={{
                                            width: 6,
                                            height: 6,
                                            borderRadius: '50%',
                                            bgcolor: currentStatus.dot,
                                            boxShadow: `0 0 6px ${currentStatus.dot}`,
                                            // Adds a little pulse if the event is "Open" (Active)
                                            animation: PA_GlobalObject.Planning.status === 0 ? 'pulse 2s infinite' : 'none'
                                        }}
                                    />
                                </Box>
                            );
                        })()}
                        <Typography sx={{ fontSize: '9px', fontWeight: 700, color: '#94a3b8', mr: 0.5, textTransform: 'uppercase' }}>
                            Current Status
                        </Typography>
                    </Box>
                </Box>
            </Paper>

            <Box className="details-list-items-container" sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <Card
                    elevation={0}
                    sx={{
                        borderRadius: '0 0 24px 24px',
                        border: '1px solid #f1f5f9',
                        borderTop: 'none',
                        bgcolor: '#fff',
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1,
                        overflow: 'hidden'
                    }}
                >
                    {/* --- MODERN NAVIGATION BAR (Replaces the old Footer) --- */}
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-around',
                            p: 1,
                            bgcolor: '#f8fafc',
                            borderBottom: '1px solid #f1f5f9'
                        }}
                    >
                        {[
                            { id: 'Name', icon: 'icon-handwriting', label: 'Name' },
                            { id: 'Cover', icon: 'icon-portrait', label: 'Cover' },
                            { id: 'Intro', icon: 'icon-file-user', label: 'Intro' },
                            { id: 'Categories', icon: 'icon-heart-shiny', label: 'Tags' },
                            { id: 'Status', icon: 'icon-sync-gear', label: 'Status' }
                        ].map((tab) => {
                            const isSelected = detailsTabSelected === tab.id;
                            return (
                                <Box
                                    key={tab.id}
                                    onClick={() => handleFooterItemClick(tab.id)}
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                        px: 2,
                                        py: 1,
                                        borderRadius: '12px',
                                        transition: 'all 0.3s ease',
                                        bgcolor: isSelected ? '#fff' : 'transparent',
                                        boxShadow: isSelected ? '0 4px 12px rgba(0,0,0,0.05)' : 'none',
                                        transform: isSelected ? 'translateY(-2px)' : 'none',
                                    }}
                                >
                                    <Badge
                                        badgeContent={tab.id === 'Categories' ? selectedEventCategories.length : 0}
                                        color="warning"
                                        sx={{ '& .MuiBadge-badge': { fontSize: '10px', height: '16px', minWidth: '16px' } }}
                                    >
                                        <i className={tab.icon} style={{
                                            color: isSelected ? '#f59e0b' : '#94a3b8',
                                            fontSize: '20px',
                                            transition: 'color 0.3s'
                                        }} />
                                    </Badge>
                                    <Typography sx={{
                                        fontSize: '10px',
                                        fontWeight: 800,
                                        mt: 0.5,
                                        color: isSelected ? '#1e293b' : '#94a3b8'
                                    }}>
                                        {tab.label}
                                    </Typography>
                                </Box>
                            );
                        })}
                    </Box>

                    <CardContent
                        sx={{
                            p: 3,
                            flex: 1,
                            overflowY: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 3,
                            '&::-webkit-scrollbar': { width: '5px' },
                            '&::-webkit-scrollbar-thumb': { bgcolor: '#e2e8f0', borderRadius: '10px' }
                        }}
                    >
                        {/* --- SECTION: NAME --- */}
                        {detailsTabSelected === "Name" && (
                            <Box sx={{ animation: 'fadeIn 0.4s ease' }}>
                                <Typography variant="overline" sx={{ fontWeight: 800, color: '#94a3b8', mb: 1, display: 'block' }}>
                                    Event Identity
                                </Typography>
                                <TextField
                                    fullWidth
                                    placeholder="Enter an awesome title..."
                                    value={eventTitle}
                                    onChange={handleEventTitleChange}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '16px',
                                            fontSize: '1.2rem',
                                            fontWeight: 700,
                                            bgcolor: '#f8fafc'
                                        }
                                    }}
                                />
                                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                                    <Chip
                                        label="Update Title"
                                        onClick={handleEventTitleUpdate}
                                        sx={{
                                            bgcolor: '#f59e0b',
                                            color: '#fff',
                                            fontWeight: 800,
                                            px: 2,
                                            height: '40px',
                                            '&:hover': { bgcolor: '#d97706' }
                                        }}
                                    />
                                </Box>
                            </Box>
                        )}

                        {/* --- SECTION: COVER --- */}
                        {detailsTabSelected === "Cover" && (
                            <Box sx={{ animation: 'fadeIn 0.4s ease' }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                    <Typography variant="overline" sx={{ fontWeight: 800, color: '#94a3b8' }}>Background Style</Typography>
                                    <div {...getRootProps()}>
                                        <input {...getInputProps()} />
                                        <Button size="small" startIcon={<i className="icon-camera" />} sx={{ fontWeight: 700, color: '#f59e0b' }}>
                                            Upload New
                                        </Button>
                                    </div>
                                </Box>

                                <Box sx={{
                                    position: 'relative', width: '100%', height: '220px', borderRadius: '20px',
                                    overflow: 'hidden', boxShadow: 'inset 0 0 40px rgba(0,0,0,0.1)', border: '4px solid #fff',
                                    opacity: PA_GlobalObject.Planning.photos?.some(p => p.photo_album) ? 0.5 : 1
                                }}>
                                    <img
                                        src={PA_GlobalObject.Planning.coverImage?.signed_url || coverImageData}
                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                        alt="Cover"
                                    />
                                    {PA_GlobalObject.Planning.photos?.some(p => p.photo_album) && (
                                        <Box sx={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'rgba(255,255,255,0.6)', backdropFilter: 'blur(4px)' }}>
                                            <Chip label="Slideshow Active" sx={{ fontWeight: 900, bgcolor: '#fff', border: '1px solid #f59e0b' }} />
                                        </Box>
                                    )}
                                </Box>

                                {needToSaveImage && (
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        onClick={() => handleEventCoverImageSave(PA_GlobalObject.Planning.photos.map(p => ({ ...p, photo_album: false })))}
                                        sx={{ mt: 2, bgcolor: '#f59e0b', borderRadius: '12px', py: 1.5, fontWeight: 800 }}
                                    >
                                        Save Manual Cover
                                    </Button>
                                )}

                                <Box sx={{ mt: 4, p: 2, bgcolor: '#f8fafc', borderRadius: '20px', border: '1px solid #e2e8f0' }}>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 1 }}>Gallery Slideshow</Typography>
                                    {PA_GlobalObject.Planning.photos?.some(p => p.photo_album) ? (
                                        <Box sx={{ display: 'flex', gap: 1, overflowX: 'auto', pb: 1 }}>
                                            {PA_GlobalObject.Planning.photos.filter(p => p.photo_album).map((p, i) => (
                                                <Avatar key={i} src={p.signed_url} variant="rounded" sx={{ width: 50, height: 50, border: '2px solid #f59e0b' }} />
                                            ))}
                                        </Box>
                                    ) : (
                                        <Typography variant="caption" sx={{ color: '#94a3b8', fontStyle: 'italic' }}>No photos selected for slideshow.</Typography>
                                    )}
                                </Box>
                            </Box>
                        )}

                        {/* --- SECTION: INTRO --- */}
                        {detailsTabSelected === "Intro" && (
                            <Box sx={{ animation: 'fadeIn 0.4s ease' }}>
                                <TextField
                                    label="Introduction / Details"
                                    multiline
                                    rows={6}
                                    fullWidth
                                    value={userInput}
                                    onChange={handleInputChange}
                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '16px', bgcolor: '#f8fafc' } }}
                                />
                                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography variant="caption" sx={{ color: '#94a3b8', fontWeight: 600 }}>HTML and rich text supported</Typography>
                                    <Box sx={{ display: 'flex', gap: 1 }}>
                                        <Chip label="Preview" onClick={renderContent} sx={{ fontWeight: 700 }} />
                                        {needToSaveIntro && (
                                            <Chip label="Save" onClick={handleEventCoverIntroSave} sx={{ bgcolor: '#22c55e', color: '#fff', fontWeight: 800 }} />
                                        )}
                                    </Box>
                                </Box>

                                <Box sx={{ mt: 4, p: 3, border: '1px dashed #cbd5e1', borderRadius: '20px', bgcolor: '#fff' }}>
                                    <Typography variant="caption" sx={{ fontWeight: 800, color: '#f59e0b', mb: 2, display: 'block' }}>LIVE PREVIEW</Typography>
                                    <div
                                        style={{ fontSize: '0.95rem', color: '#475569', lineHeight: 1.6 }}
                                        dangerouslySetInnerHTML={{ __html: sanitizedContent || '<i>Awaiting content...</i>' }}
                                    />
                                </Box>
                            </Box>
                        )}


                        {/* --- SECTION: CATEGORIES --- */}
                        {detailsTabSelected === "Categories" && (
                            <Box
                                sx={{
                                    animation: 'fadeIn 0.4s ease',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    height: '100%',
                                    maxHeight: '480px', // Matches your card content viewport height
                                    overflow: 'hidden'
                                }}
                            >
                                {/* 1. ANCHORED TOP: Selected Categories Header & List */}
                                <Box sx={{ flexShrink: 0, pb: 1.5, borderBottom: '1px solid #f1f5f9' }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                        <Typography variant="overline" sx={{ fontWeight: 800, color: '#f59e0b', fontSize: '0.7rem', letterSpacing: '0.5px' }}>
                                            Selected Tags ({selectedEventCategories.length})
                                        </Typography>
                                        {selectedEventCategories.length === 0 && (
                                            <Typography variant="caption" sx={{ color: '#94a3b8', fontStyle: 'italic', fontSize: '0.75rem' }}>
                                                None selected yet
                                            </Typography>
                                        )}
                                    </Box>

                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, maxHeight: '110px', overflowY: 'auto', pr: 0.5 }}>
                                        {eventCategories
                                            .filter(cat => selectedEventCategories.includes(cat))
                                            .map((cat) => (
                                                <Chip
                                                    key={cat}
                                                    label={cat}
                                                    onDelete={() => handleEventCategoryToggleSelectedCategory(cat)}
                                                    onClick={() => handleEventCategoryToggleSelectedCategory(cat)}
                                                    sx={{
                                                        fontWeight: 800,
                                                        bgcolor: '#fef3c7',
                                                        color: '#b45309',
                                                        border: '1px solid #f59e0b',
                                                        '& .MuiChip-deleteIcon': { color: '#d97706', '&:hover': { color: '#b45309' } },
                                                        '&:hover': { transform: 'scale(1.02)' }
                                                    }}
                                                />
                                            ))}
                                    </Box>
                                </Box>

                                {/* 2. SCROLLABLE MIDDLE: Unselected Categories */}
                                <Box
                                    sx={{
                                        flex: 1,
                                        overflowY: 'auto',
                                        py: 2,
                                        pr: 0.5,
                                        '&::-webkit-scrollbar': { width: '4px' },
                                        '&::-webkit-scrollbar-thumb': { bgcolor: '#cbd5e1', borderRadius: '10px' }
                                    }}
                                >
                                    <Typography variant="overline" sx={{ fontWeight: 800, color: '#94a3b8', mb: 1, display: 'block', fontSize: '0.65rem' }}>
                                        Available Tags
                                    </Typography>

                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                        {eventCategories
                                            .filter(cat => !selectedEventCategories.includes(cat))
                                            .map((cat) => (
                                                <Chip
                                                    key={cat}
                                                    label={cat}
                                                    onClick={() => handleEventCategoryToggleSelectedCategory(cat)}
                                                    sx={{
                                                        fontWeight: 700,
                                                        bgcolor: '#fff',
                                                        color: '#64748b',
                                                        border: '1px solid #e2e8f0',
                                                        '&:hover': { bgcolor: '#f8fafc', borderColor: '#cbd5e1', transform: 'scale(1.02)' }
                                                    }}
                                                />
                                            ))}
                                    </Box>
                                </Box>

                                {/* 3. ANCHORED BOTTOM: Custom Tag Input & Apply Preferences Button */}
                                <Box sx={{ flexShrink: 0, pt: 2, borderTop: '1px solid #f1f5f9', bgcolor: '#fff' }}>
                                    <Box sx={{ display: 'flex', gap: 1, mb: 1.5 }}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            placeholder="Add custom tag..."
                                            value={newCategory}
                                            onChange={handleEventCategoryNewCategory}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    handleEventCategoryAddNewCategory();
                                                }
                                            }}
                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px', bgcolor: '#f8fafc' } }}
                                        />
                                        <Button
                                            variant="contained"
                                            onClick={handleEventCategoryAddNewCategory}
                                            sx={{ bgcolor: '#1e293b', borderRadius: '12px', fontWeight: 800, textTransform: 'none', px: 2.5 }}
                                        >
                                            Add
                                        </Button>
                                    </Box>

                                    <Button
                                        fullWidth
                                        disabled={!enableUpdateButton}
                                        onClick={handleEventCategoriesUpdate}
                                        sx={{
                                            py: 1.2,
                                            borderRadius: '12px',
                                            bgcolor: enableUpdateButton ? '#f59e0b' : '#f1f5f9',
                                            color: enableUpdateButton ? '#fff' : '#94a3b8',
                                            fontWeight: 900,
                                            textTransform: 'none',
                                            fontSize: '0.9rem',
                                            boxShadow: enableUpdateButton ? '0 4px 12px rgba(245, 158, 11, 0.25)' : 'none',
                                            '&:hover': { bgcolor: enableUpdateButton ? '#d97706' : '#f1f5f9' }
                                        }}
                                    >
                                        Apply Preferences
                                    </Button>
                                </Box>
                            </Box>
                        )}

                        {/* --- SECTION: STATUS --- */}
                        {detailsTabSelected === "Status" && (
                            <Box sx={{ animation: 'fadeIn 0.4s ease', textAlign: 'center', py: 2 }}>
                                <Typography variant="h6" sx={{ fontWeight: 800, mb: 3 }}>
                                    Current Progress
                                </Typography>

                                {/* Notice Banner when event is unpaid/un-saved and currently in Planning phase */}
                                {PA_GlobalObject.Planning.status === 10 && !isEventSavedAndPaid && (
                                    <Alert
                                        severity="info"
                                        variant="outlined"
                                        sx={{
                                            mb: 3,
                                            borderRadius: '16px',
                                            textAlign: 'left',
                                            alignItems: 'center',
                                            bgcolor: '#f0fdf4',
                                            borderColor: '#10b981'
                                        }}
                                    >
                                        <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#065f46' }}>
                                            Ready to Make It Official? 🚀
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: '#047857', fontSize: '0.85rem' }}>
                                            Save and activate your event to unlock status updates, live notifications, and real-time syncing!
                                        </Typography>
                                    </Alert>
                                )}

                                <FormControl fullWidth>
                                    <Select
                                        value={status}
                                        onChange={handleEventStatusUpdate}
                                        sx={{ borderRadius: '16px', fontWeight: 700, bgcolor: '#f8fafc' }}
                                    >
                                        <MenuItem value={10}>
                                            📝 Planning Phase
                                        </MenuItem>

                                        {/* Options are greyed out if still in Planning (10) and unpaid */}
                                        <MenuItem
                                            value={0}
                                            disabled={PA_GlobalObject.Planning.status === 10 && !isEventSavedAndPaid}
                                        >
                                            ✅ Open / Active
                                        </MenuItem>
                                        <MenuItem
                                            value={2}
                                            disabled={PA_GlobalObject.Planning.status === 10 && !isEventSavedAndPaid}
                                        >
                                            📅 Rescheduled
                                        </MenuItem>
                                        <MenuItem
                                            value={1}
                                            disabled={PA_GlobalObject.Planning.status === 10 && !isEventSavedAndPaid}
                                        >
                                            🔒 Closed
                                        </MenuItem>
                                        <MenuItem
                                            value={3}
                                            disabled={PA_GlobalObject.Planning.status === 10 && !isEventSavedAndPaid}
                                        >
                                            ❌ Cancelled
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>
                        )}
                    </CardContent>
                </Card>
            </Box>

        </div>
    )
}

export default DetailsView;
